<div>
  <h2>Verify Load Details</h2>
  <p class="border-b-2 border-gray-400">
    I have validated the Sand Vendor BOL number and load quantity as provided by the Driver. I confirm this record is
    correct and complete.
  </p>

  <form *ngIf="verifyLoadDetailsForm" class="grid grid-cols-1" [formGroup]="verifyLoadDetailsForm">
    <div class="flex flex-col my-3 mx-0 gap-1">
      <mat-form-field>
        <input type="text" matInput formControlName="poNumber" autocomplete="off" placeholder="PO Number" />
      </mat-form-field>

      <mat-form-field>
        <input type="text" matInput formControlName="bolNumber" autocomplete="off" placeholder="BOL Number" />
      </mat-form-field>

      <ng-container *ngIf="!order.boxes; else boxStorage">
        <mat-form-field>
          <input
            matInput
            type="number"
            formControlName="finalLoadWeight"
            placeholder="Final Load Weight"
            autocomplete="off"
          />
          <mat-hint *ngIf="verifyLoadDetailsForm.get('finalLoadWeight')?.value | poundsToTons as tons">
            {{ tons }}
          </mat-hint>
          <mat-error *ngIf="verifyLoadDetailsForm.get('finalLoadWeight').hasError('max')">
            This looks very high. Are you sure this is correct?
          </mat-error>
        </mat-form-field>
      </ng-container>

      <ng-template #boxStorage>
        <ng-container *ngIf="order?.boxes" formArrayName="boxes">
          <ng-container
            class="box-wrap"
            *ngFor="let box of boxes.controls; trackBy: trackById; let i = index"
            [formGroupName]="i"
          >
            <mat-form-field>
              <input
                matInput
                min="0"
                type="number"
                placeholder="Final Box {{ i + 1 }} Load Weight (lbs)"
                formControlName="finalLoadWeight"
              />
              <mat-hint>
                {{ getWeightInTon(box.get('finalLoadWeight').value) }}
              </mat-hint>
              <mat-error
                *ngIf="box.get('finalLoadWeight').hasError('max')"
                saAutomatedSelector="order-details__box_weight_error"
              >
                This looks very high. Are you sure this is correct?
              </mat-error>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </ng-template>
    </div>

    <div class="flex justify-between">
      <button mat-raised-button mat-dialog-close>
        Cancel
      </button>
      <button
        mat-raised-button
        color="warn"
        [disabled]="verifyLoadDetailsForm.invalid"
        (click)="submitVerification('reject')"
      >
        Reject
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="verifyLoadDetailsForm.invalid"
        (click)="submitVerification('verify')"
      >
        Verify
      </button>
    </div>
  </form>
</div>
